import BigNumber from 'bignumber.js'
import createDependableResource from 'utils/zustand/createDependableResource'
import { useDeserializedFarms } from 'state/farms/useDeserializedFarms'
import { useFinishedFarmsPeriodicFetching } from 'state/farms/farmsPeriodicFetching'
import { immediatePromise } from 'utils/waitPromise'
import { TOKEN_PRICE_MAPPING } from 'config/constants/tokenPriceMappings'

export type FarmTokensPricesUsdc = Record<string, number>

const getFarmTokensPricesUsdc = (): FarmTokensPricesUsdc => {
  const prices = {} as FarmTokensPricesUsdc

  useDeserializedFarms.getState().value.farms.forEach((farm) => {
    const quoteTokenAddress = farm.quoteToken.address.toLocaleLowerCase()
    const tokenAddress = farm.token.address.toLocaleLowerCase()
    if (!prices[quoteTokenAddress]) {
      prices[quoteTokenAddress] = new BigNumber(farm.quoteTokenPriceUsdc).toNumber()
    }
    if (!prices[tokenAddress]) {
      prices[tokenAddress] = new BigNumber(farm.tokenPriceUsdc).toNumber()
    }
  }, {})

  Object.entries(TOKEN_PRICE_MAPPING).forEach(([tokenAddr, priceFromTokenAddr]) => {
    if (!prices[tokenAddr]) {
      prices[tokenAddr] = new BigNumber(prices[priceFromTokenAddr]).toNumber()
    }
  })

  return prices
}

/**
 * NOTE: this does not guarantee price data (will be) loaded
 */
export const useFarmTokensPricesUsdc = createDependableResource<FarmTokensPricesUsdc>({
  initValue: {},
  getValue: getFarmTokensPricesUsdc,
  dependResources: [useDeserializedFarms],
  dbgName: 'FarmTokensPricesUsdc',
})

/**
 * NOTE: will query finished farms data as well to get complete token prices
 */
export const getAllLoadedFarmTokenPrices = async () => {
  await useFinishedFarmsPeriodicFetching.untilRefreshedOnce()
  await immediatePromise()
  return useFarmTokensPricesUsdc.getState().getLoadedValue()
}
